
const digest = 'fd01b66dcf67c003c95261fb11e0bfede6c359f3d737469e85084f06ac12d1e2';
const classes = {"wrapper":"_wrapper_xfbck_1"};
const css = `._wrapper_xfbck_1 {
  font-family: Rubik, "sans-serif";
  height: 100%;
  display: flex;
  flex-direction: column;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  